import { CheckCircle2, XCircle, Clock } from "lucide-react";

const DOC_LABELS = {
  aadhaar: "Aadhaar", pan: "PAN / ID", photo: "Passport Photo",
  college_id: "College / Office ID", rental_agreement: "Rental Agreement", other: "Other",
};

const BADGES = {
  verified: ["bg-green-100 text-green-800", CheckCircle2, "Verified"],
  rejected: ["bg-red-100 text-red-800", XCircle, "Rejected"],
  pending: ["bg-orange-100 text-orange-800", Clock, "Pending"],
};

function StatusBadge({ status }) {
  const [cls, Icon, label] = BADGES[status] || BADGES.pending;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 text-xs uppercase tracking-wider font-semibold ${cls}`}>
      <Icon className="h-3 w-3" /> {label}
    </span>
  );
}

function DocRow({ d, onView, onApprove, onReject }) {
  return (
    <tr className="border-b border-slate-100 hover:bg-slate-50">
      <td className="px-6 py-4">
        <div className="font-medium">{d.tenant_name || "—"}</div>
        <div className="text-xs text-slate-500 font-mono">{d.tenant_phone}</div>
      </td>
      <td className="px-6 py-4">
        <div className="font-medium">{DOC_LABELS[d.doc_type] || d.doc_type}</div>
        <button onClick={() => onView(d)} data-testid={`view-${d.id}`} className="text-xs text-blue-600 hover:underline">View file</button>
      </td>
      <td className="px-6 py-4 text-xs text-slate-500">{new Date(d.created_at).toLocaleDateString()}</td>
      <td className="px-6 py-4"><StatusBadge status={d.status} /></td>
      <td className="px-6 py-4 text-xs text-slate-600">{d.admin_remark || "—"}</td>
      <td className="px-6 py-4 text-right space-x-1">
        {d.status !== "verified" && (
          <button onClick={() => onApprove(d.id)} data-testid={`approve-${d.id}`}
                  className="bg-green-600 text-white px-3 py-1.5 text-xs uppercase tracking-wider hover:bg-green-700">Approve</button>
        )}
        {d.status !== "rejected" && (
          <button onClick={() => onReject(d.id)} data-testid={`reject-${d.id}`}
                  className="bg-red-600 text-white px-3 py-1.5 text-xs uppercase tracking-wider hover:bg-red-700">Reject</button>
        )}
      </td>
    </tr>
  );
}

export function DocTable({ docs, ...handlers }) {
  return (
    <table className="w-full">
      <thead className="bg-slate-50">
        <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b">
          <th className="px-6 py-3">Tenant</th><th className="px-6 py-3">Document</th>
          <th className="px-6 py-3">Submitted</th><th className="px-6 py-3">Status</th>
          <th className="px-6 py-3">Admin note</th><th className="px-6 py-3"></th>
        </tr>
      </thead>
      <tbody>
        {docs.map((d) => <DocRow key={d.id} d={d} {...handlers} />)}
      </tbody>
    </table>
  );
}
